// extracted by mini-css-extract-plugin
export default {"sad":"JNwlVO8JIB2vB6zNgJfT"};